var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row mx-0"},[_c('menu-categorias',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewMenuCategorias),expression:"viewMenuCategorias"}]}),_c('div',{staticClass:"col"},[_c('categoria-detalle')],1),_c('section-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }